var map = {
	"./box_border_1.png": 163,
	"./box_header_1.png": 207,
	"./capture_border.png": 208,
	"./capture_border_green.png": 209,
	"./capture_border_red.png": 210,
	"./contact.png": 319,
	"./faq.png": 320,
	"./header.png": 321,
	"./header_logo.png": 322,
	"./header_logo_plate.png": 323,
	"./icon_camera.png": 211,
	"./icon_capture.png": 212,
	"./icon_capture_white.png": 213,
	"./icon_checkout.png": 164,
	"./icon_clock.png": 214,
	"./icon_confidence.png": 215,
	"./icon_datetime.png": 216,
	"./icon_default_image_disabled.png": 165,
	"./icon_default_image_enabled.png": 166,
	"./icon_delete.png": 96,
	"./icon_delete_image.png": 58,
	"./icon_edit.png": 73,
	"./icon_enter.png": 167,
	"./icon_exit.png": 168,
	"./icon_female.png": 217,
	"./icon_group.png": 218,
	"./icon_live.png": 219,
	"./icon_live_white.png": 220,
	"./icon_male.png": 221,
	"./icon_member_info.png": 222,
	"./icon_members.png": 223,
	"./icon_menu.png": 169,
	"./icon_permission.png": 224,
	"./icon_permission_white.png": 225,
	"./icon_plate.png": 226,
	"./icon_rating.png": 127,
	"./icon_report.png": 227,
	"./icon_report_white.png": 228,
	"./icon_settings.png": 229,
	"./icon_similarity.png": 230,
	"./icon_similarity2.png": 231,
	"./icon_target.png": 232,
	"./icon_target_white.png": 233,
	"./icon_user.png": 52,
	"./icon_user_white.png": 234,
	"./inbox.png": 170,
	"./live.png": 235,
	"./login_border.png": 324,
	"./login_footer.png": 325,
	"./login_footer_plate.png": 326,
	"./login_header.png": 327,
	"./login_header_plate.png": 328,
	"./logo_face.png": 329,
	"./plate.png": 236,
	"./purchase.png": 171,
	"./thumb_down.png": 108,
	"./thumb_up.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;